/* eslint-disable no-mixed-spaces-and-tabs */
import React, { useMemo } from 'react';
import { formatCurrency, safelyParseFloat } from '@/utils/constants';
import { Grid } from '@mui/material';
import TotalCard from './TotalCard';
import { useFeatureFlagContext } from '@/context/featureFlagContext';

const PolicyTotalsHeader = ({ data, isLoading, isError }) => {
	const { getFeatureFlags } = useFeatureFlagContext();
	const showRenewalAmountColumn = Boolean(
		getFeatureFlags('showRenewalAmountColumn')?.active,
	);

	const totalPolicies = useMemo(
		() => Array.from(new Set(data.map((page) => page.Id))).length,
		[data],
	);
	const totalClients = useMemo(
		() => Array.from(new Set(data.map((page) => page.ClientId))).length,
		[data],
	);
	const totalPremiums = useMemo(
		() => data.reduce((acc, page) => acc + safelyParseFloat(page.Balance ?? 0), 0),
		[data],
	);

	const totalCardSx = {
		'& .MuiTypography-root': {
			fontSize: '22px !important',
		},
		'& .MuiTypography-h4, & .MuiTypography-h5, & .MuiTypography-h6': {
			fontSize: '22px !important',
		},
		'& .MuiCardHeader-title, & .MuiCardHeader-subheader': {
			fontSize: '22px !important',
		},
	};

	return (
		<Grid container rowSpacing={1} columnSpacing={2} width='100%'>
			<Grid size={{ sm: 12, md: showRenewalAmountColumn ? 4 : 6 }}>
				<TotalCard
					title='Total Policies'
					total={totalPolicies}
					sx={totalCardSx}
					{...{ isLoading, isError }}
				/>
			</Grid>
			<Grid size={{ sm: 12, md: showRenewalAmountColumn ? 4 : 6 }}>
				<TotalCard
					title='Total Clients'
					total={totalClients}
					sx={totalCardSx}
					{...{ isLoading, isError }}
				/>
			</Grid>
			{showRenewalAmountColumn && (
				<Grid size={{ sm: 12, md: 4 }}>
					<TotalCard
						title='Total Premiums'
						total={formatCurrency({ num: totalPremiums })}
						sx={totalCardSx}
						{...{ isLoading, isError }}
					/>
				</Grid>
			)}
		</Grid>
	);
};
export default PolicyTotalsHeader;
